define.alias("shared/helpers/format-number-to-locale-string", "media/helpers/format-number-to-locale-string");